import React from "react";
import { mapContextDeviceToDataTable as mapData } from "./Helper";
import ReusableDataTable from "src/components/table/ReusableDataTable";
import GetContextDeviceColumns from "./ColumnDefinition/ContextDeviceColumn/GetContextDeviceColumns";

const ContextDeviceTable = ({
  data,
  handleOpenPopup,
  handleDelete,
  status,
}) => {
  const columns = GetContextDeviceColumns({
    handleOpenPopup,
    handleDelete,
    status,
  });

  return (
    <ReusableDataTable columns={columns} data={mapData(data)} maxHeight={500} />
  );
};

export default ContextDeviceTable;
